<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" :rules="formRules" ref="queryForm" :inline="true">
          <div class="flex-box">
            <!-- <img src="../../../assets/down.png" class="down" alt=""> -->

            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                {{query.timeType === 1?'日':(query.timeType === 2?'周':'月')}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">日</el-dropdown-item>
                <el-dropdown-item command="3">月</el-dropdown-item>
                <el-dropdown-item command="2">周</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-form-item label="距离会议时间：" class="is-required" prop="day" style="display:flex">
              <el-input placeholder="请输入" v-model="query.day" size="small" class="input-with-select" />
            </el-form-item>
          </div>
          <el-form-item label="会议名称：" class="is-required">
            <el-select v-model="query.barrierId" placeholder="请选择" filterable clearable size="small">
              <el-option v-for="(item,index) in options.meetingOptions" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户类型：">
            <el-select v-model="query.customerType" placeholder="请选择" clearable size="small">
              <el-option label="新客户" :value="0"></el-option>
              <el-option label="老客户" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户分类：">
            <el-select v-model="query.customerClassifyId" placeholder="请选择" filterable clearable size="small">
              <el-option v-for="(item,index) in options.customerClass" :key="index" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <template v-if="isShowEcharts">
        <div class="title-txt">收款统计</div>
        <echarts-vue :echart-data="echartData" echartName="echarts" v-if="echartData && echartData.yAxisData" />
        <div class="title-txt">出货统计</div>
        <echarts-vue :echart-data="echartData1" echartName="echarts" v-if="echartData1 && echartData1.yAxisData" />
      </template>
      <template v-if="list && list.length > 0">
        <div class="title-txt">合格学员统计<img src="../../../assets/down.png" class="down" alt=""></div>
        <el-table v-loading="listLoading" :data="list">
          <el-table-column label="用户信息" prop="realName" align="center" />
          <el-table-column label="用户身份" prop="identity" align="center" />
          <el-table-column label="用户手机号" prop="userPhone" align="center" />
          <el-table-column label="客户分类" prop="customerClassify" align="center" />
          <el-table-column label="关卡名称" prop="barrierName" align="center" />
          <el-table-column label="闯关模式" prop="barrierTypeName" align="center" />
          <el-table-column label="闯关阶段" prop="barrierStageNum" align="center" />
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      </template>
    </el-card>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination'
import DataBoardApi from '@/api/dataBoard/DataBoard'
import echartsVue from "../components/echarts.vue";
import customerClassifyApi from '@/api/config/customerClassify'
import courseSubjectBarrierApi from '@/api/course/courseSubjectBarrier'
import { Subtr } from '@/utils/index'
export default {
  components: {
    Pagination,
    echartsVue
  },
  data() {
    return {
      list: [],
      listLoading: true,
      total: 0,
      query: {
        timeType: 1,
        pageNo: 1,
        pageSize: 10
      },
      customerOptions: [],
      echartsData: [],
      echartsData1: [],
      xData: [],
      formRules: {
        day: [{ pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }]
      },
      options: {
        customerClass: [],
        meetingOptions: [],
      },
      searchVal: '',
      isShowEcharts: false
    }
  },
  created() {
    this.getCustomerClass()
    this.getMeetingList()
  },
  methods: {
    //获取客户分类
    getCustomerClass() {
      customerClassifyApi.findOptions().then(res => {
        this.options.customerClass = res.data.reverse()
      })
    },
    //会议名称
    getMeetingList() {
      courseSubjectBarrierApi.fetchList({ pageNo: 1, pageSize: 1000 }).then(data => {
        this.options.meetingOptions = data.data.list
      })
    },
    handleCommand(command) {
      this.query.timeType = +command
    },
    calcQuery() {
      let params = JSON.parse(JSON.stringify(this.query))
      params.day = params.day ? +params.day : undefined
      return params
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let params = this.calcQuery()
      this.listLoading = true
      return DataBoardApi.onlineServiceAnalysisList(params)
        .then(data => {
          let { list, total } = data.data
          this.list = list;
          console.log(this.list)
          this.total = total
        }).finally(() => {
          this.listLoading = false
        })
    },
    handleQuery() {
      let { day, timeType, barrierId } = this.query;
      if (!day) return this.$message.warning('请输入距离会议时间')
      if (!timeType) return this.$message.warning('请选择时间粒度')
      if (!barrierId) return this.$message.warning('请选择会议名称')
      this.submitForm()
    },
    submitForm() {
      this.$refs["queryForm"].validate((valid) => {
        if (valid) {
          this.doQueryList({})
          this.getPaymentStatis()
          this.getShipmentStatis()
        }
      })
    },
    //收款统计
    getPaymentStatis() {
      let params = this.calcQuery()
      delete params.pageNo
      delete params.pageSize
      DataBoardApi.onlineServiceAnalysisPayK(params).then(({ data }) => {
        if (data.length > 0) {
          data.forEach(item => {
            item.ratio = Subtr(item.afterMoney, item.beforeMoney) / item.beforeMoney * 100;
          })
          this.calcDate(data)
          this.getEcharts(data)
          this.isShowEcharts = true
        } else {
          this.isShowEcharts = false
          this.$message.warning('暂无数据')
        }
      })
    },
    //出货统计
    getShipmentStatis() {
      let params = this.calcQuery()
      delete params.pageNo
      delete params.pageSize
      DataBoardApi.onlineServiceAnalysisShipmentK(params).then(({ data }) => {
        if (data.length > 0) {
          data.forEach(item => {
            item.ratio = Subtr(item.afterMoney, item.beforeMoney) / item.beforeMoney * 100;
          })
          this.calcDate(data)
          this.getEcharts1(data)
          this.isShowEcharts = true
        } else {
          this.isShowEcharts = false
        }
      })
    },
    getEcharts(echartsData) {
      this.echartsData = this.synthesisSeriesData(echartsData, [
        { name: "会议前业绩", color: "#FED15C", key: "beforeMoney", time: "beforeStartTime" },
        { name: "会议后业绩", color: "#F3715B", key: "afterMoney", time: "startTime" },
      ], "line")
    },
    getEcharts1(echartsData) {
      this.echartsData1 = this.synthesisSeriesData(echartsData, [
        { name: "会议前出货", color: "#FED15C", key: "beforeCount", time: "beforeStartTime" },
        { name: "会议后出货", color: "#F3715B", key: "afterCount", time: "startTime" },
      ], "line")
    },
    calcDate(data) {
      let { timeType } = this.query;
      let dateList = []
      if (timeType === 1) {
        data.forEach((item, index) => {
          item.date = `第${index + 1}日`
          // item.date = item.startTime.substr(0, 10).replace(/\-/g, "/")
        });
        dateList = data.map(item => item.date)
      } else if (timeType === 2) {
        data.forEach((item, index) => {
          let date = item.startTime.substr(0, 10).replace(/\-/g, "/")
          dateList.push(`第${index + 1}周 ${date}`)
        });

      } else if (timeType === 3) {
        data.forEach(item => {
          item.date = item.startTime.substr(0, 7).replace(/\-/g, "/")
        });
        dateList = data.map(item => item.date)
      }
      this.xData = dateList
    },

    //合成图标Y轴信息
    synthesisSeriesData(datalist, ydata, chartType) {
      let param = {}, itemStyle = {};
      if (chartType === 'line') {
        param = { type: "line", smooth: true, symbolSize: 10 };
      }
      return ydata.map(item => {
        let dataArr = []
        datalist.forEach(itt => {
          dataArr.push({ value: itt[item.key], dataType: 1, time: itt[item.time] })
        })
        return {
          name: item.name, ...param, data: dataArr,
          itemStyle: { ...itemStyle, color: item.color }
        }
      })
    }

  },
  computed: {
    echartData() {
      return {
        // legendData: item.dataList.map(it => it.title),
        xAxisData: this.xData,
        yAxisData: this.echartsData
      };
    },
    echartData1() {
      return {
        // legendData: item.dataList.map(it => it.title),
        xAxisData: this.xData,
        yAxisData: this.echartsData1
      };
    }
  },
}
</script>
<style lang="scss" scoped>
.down {
  width: 34px;
  height: 34px;
  margin-right: 10px;
  cursor: pointer;
}
.flex-box {
  display: flex;
  flex-direction: row-reverse;
}
.el-dropdown {
  line-height: 42px;
  margin-right: 10px;
}
.title-txt {
  font-size: 18px;
  color: #000;
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    width: 34px;
    height: 34px;
  }
}
</style>
